const React = require("react");

function ExclamationCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = ExclamationCircleIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ExclamationCircleIcon.js
 ** module id = 521
 ** module chunks = 0
 **/